import { FadeElement } from './FadeElement';
import { addScrollListener } from './scrollListener';

function setHeader() {
  const header = document.querySelector('.header');
  addScrollListener(() => {
    if (window.scrollY > 0) {
      header.classList.add('is-fixed');
    }
    else {
      header.classList.remove('is-fixed');
    }
  });
}
setHeader();

function setFloatBtn() {
  const floatBtn = document.querySelector('.float-btn');
  const fadeFloatBtnInstance = new FadeElement(floatBtn);
  addScrollListener(() => {
    if (window.scrollY > 100) {
      fadeFloatBtnInstance.fadeIn(500);
    }
    else {
      fadeFloatBtnInstance.fadeOut(500);
    }
  });

  const topBtn = floatBtn.querySelector('.top-btn');
  topBtn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
setFloatBtn();
